"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFiocInterstitialBase = void 0;
const React = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const features_1 = require("../../../features");
const tracker_1 = require("../../../tracker");
const hooks_1 = require("../../../hooks");
const PROFILE_PATH = '/profile';
const EMPTY_STRING = '';
const useFiocInterstitialBase = ({ fiocData, profileRepository }) => {
    const { infoKycDto } = fiocData;
    const history = (0, react_router_dom_1.useHistory)();
    const { getProfileCall, profileData } = (0, hooks_1.useProfileServiceBase)(profileRepository);
    const [isOpen, setIsOpen] = React.useState(true);
    React.useEffect(() => {
        getProfileCall();
        tracker_1.tracker.track(features_1.FiocTrackingActions.FIOC_INTERSTITIAL_OPEN_MODAL);
    }, []);
    const handleCrossClose = () => {
        tracker_1.tracker.track(features_1.FiocTrackingActions.FIOC_INTERSTITIAL_CROSS_ICON);
        setIsOpen(false);
    };
    const handleCancelLink = () => {
        tracker_1.tracker.track(features_1.FiocTrackingActions.FIOC_INTERSTITIAL_CANCEL_LINK);
        setIsOpen(false);
    };
    const handleGoToProfile = () => {
        tracker_1.tracker.track(features_1.FiocTrackingActions.FIOC_INTERSTITIAL_GO_TO_PROFILE_BUTTON);
        history.push(PROFILE_PATH);
    };
    return {
        handleGoToProfile,
        handleCrossClose,
        handleCancelLink,
        isOpen,
        isExpired: (0, features_1.getIsFiocExpired)(infoKycDto.days),
        userName: profileData?.data.userDetails.alias || profileData?.data.userDetails.firstName || EMPTY_STRING,
        nextReviewDate: infoKycDto.nextReviewDate,
    };
};
exports.useFiocInterstitialBase = useFiocInterstitialBase;
//# sourceMappingURL=useFiocInterstitialBase.hook.js.map